<template>
  <ul class="tab">
    <li
      v-for="({ title, url }, index) in visibleList"
      :key="index"
      :class="{ active: $route.path == url }"
      @click="$router.push(url)"
    >
      {{ title }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'WelfareTab',
  props: {
    // coupon | task
    type: { type: String, default: 'coupon' },
  },
  computed: {
    list() {
      if (this.type === 'task') {
        return [
          {
            title: '任务管理',
            url: '/home/welfare/management',
            perm: 'tenant:welfare_task_mgmt:tab_management',
          },
          {
            title: '任务发放记录',
            url: '/home/welfare/taskRecord',
            perm: 'tenant:welfare_task_mgmt:issue_record',
          },
        ]
      }
      return [
        { title: '卡券管理', url: '/home/welfare/coupon' },
        {
          title: '卡券发放记录',
          url: '/home/welfare/couponRecord',
          perm: 'tenant:coupon_mgmt:issue_record',
        },
      ]
    },
    visibleList() {
      return this.list.filter((item) => !item.perm || this.$hasPerm(item.perm))
    },
  },
}
</script>

<style lang="less" scoped>
.tab {
  display: flex;
  list-style: none;
  gap: 16px;
  padding: 0;
  margin: 0 0 8px;
  li {
    cursor: pointer;
    &:hover {
      color: #707aff;
    }
  }
  .active {
    color: #707aff;
  }
}
</style>
